import type { FC } from "react";

import { Tile as UITile } from "@jti/ui/components/Tile";

import type { tileInputs } from "./Tile.builder";

type TileBuilderProps = BuilderComponentProps<typeof tileInputs>;

export const Tile: FC<TileBuilderProps> = ({ title, href, ctaText, content }) => {
  return <UITile title={title} href={href} ctaText={ctaText} content={content} />;
};
